<template lang="pug">
v-switch(
    v-model="switchInput"
    :label="label"
    :error-messages="messages"
    @change='formValidate'
    v-bind="{...$props.attr}"
)
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
    label: String,
    messages: Array,
    attr: {
      type: Object,
      default: function () {
        return { class: "mt-0", "hide-details": "" };
      },
    },
  },
  data: () => ({}),
  computed: {
    switchInput: {
      get() {
        this.$emit("input", this.$props.value);
        return this.$props.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    async formValidate() {
      await this.$emit("formValidate");
    },
  },
};
</script>
